import {
  Container,
  Box,
  Typography,
  Tab,
  Tabs,
  Grid,
  Button,
  IconButton,
  Modal,
  TextField,
} from "@mui/material";
import React, { Fragment, useState, useEffect } from "react";
import Layout from "../components/layouts/Layout";
import PropTypes from "prop-types";
import Breadcrumbs from "../components/breadcrumbs/";
import OrderListing from "./OrderListing";
import UserAddress from "./UserAddress";
import CloseIcon from '@mui/icons-material/Close';
import { useProfile } from "../context/ProfileContext"; 

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={"span"} variant={"body2"}>
            {children}
          </Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const Account = () => {
  const { UserInfo, editProfile } = useProfile(); 
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [openPass, setOpenPass] = useState(false);

  const [user, setUser] = useState({
    username: UserInfo?.name || "",
    email: UserInfo?.email || "",
    mobile: UserInfo?.phone || "",
  });

  useEffect(() => {
    if (UserInfo) {
      setUser({
        username: UserInfo?.name,
        email: UserInfo?.email,
        mobile: UserInfo?.phone,
      });
    }
  }, [UserInfo]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const EditUserData = () => {
    editProfile(user.username, user.mobile, user.email); 
    handleClose();
  };

  // Password handling
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({ ...passwordData, [name]: value });
  };

  const handleOpenPass = () => setOpenPass(true);
  const handleClosePass = () => setOpenPass(false);

  const handleChangePassword = () => {
    console.log('Current Password:', passwordData.currentPassword);
    console.log('New Password:', passwordData.newPassword);
    console.log('Confirm New Password:', passwordData.confirmNewPassword);

    handleClosePass();
  };

  return (
    <Fragment>
      <Layout title={"Accounts"} logo={"/assets/images/logo.jpeg"}>
        <Breadcrumbs title={"Accounts"} crumb={"Accounts"} />
        <Container>
          <div className="profile-sec">
            <Grid container spacing={2}>
              <Grid item sx={{ textAlign: "end" }}>
                <Button variant="outlined" color="error" onClick={handleOpen}>
                  Edit Profile
                </Button>
              </Grid>
              <Grid item sx={{ textAlign: "end" }}>
                <Button variant="outlined" color="error" onClick={handleOpenPass}>
                  Change Password
                </Button>
              </Grid>
            </Grid>
          </div>

          {/* Desktop Tabs */}
          <div className="desktop-tabs">
            <Box sx={{ flexGrow: 1, bgcolor: "background.paper", display: "flex" }}>
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                className="vertical-tab"
                aria-label="Vertical tabs example"
                sx={{
                  borderRight: 1,
                  borderColor: "divider",
                }}
              >
                <Tab label={"My Orders"} {...a11yProps(0)} className="tabs-btn" />
                <Tab label={"My Addresses"} {...a11yProps(1)} className="tabs-btn" />
              </Tabs>

              <TabPanel value={value} index={0}>
                <OrderListing />
              </TabPanel>

              <TabPanel value={value} index={1}>
                <Box sx={{ paddingBottom: "10px", }}>
                  <Typography variant="h5" component="h2" sx={{ fontWeight: "bold", }}>
                    My Addresses
                  </Typography>
                  <Typography variant="subtitle1" component="p" sx={{ color: "rgb(120, 120, 120)", marginTop: "10px" }}>
                    List of all delivery/booking addresses
                  </Typography>
                </Box>
                <UserAddress />
              </TabPanel>
            </Box>
          </div>

          {/* Mobile Tabs */}
          <div className="mobile-tabs">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                aria-label="scrollable auto tabs example"
              >
                <Tab label={"My Orders"} {...a11yProps(0)} className="tabs-btn" />
                <Tab label={"My Addresses"} {...a11yProps(1)} className="tabs-btn" />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <OrderListing />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Box sx={{ paddingBottom: "10px", }}>
                <Typography variant="body2" component="h2" sx={{ fontWeight: "bold", }}>
                  My Addresses
                </Typography>
                <Typography variant="caption" component="p" sx={{ color: "rgb(120, 120, 120)", marginTop: "10px" }}>
                  List of all delivery/booking addresses
                </Typography>
              </Box>
              <UserAddress />
            </TabPanel>
          </div>

          {/* Modal for Editing User Data */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="edit-modal">
              <IconButton
                onClick={handleClose}
                style={{ position: 'absolute', top: '10px', right: '10px' }}
              >
                <CloseIcon />
              </IconButton>
              <Typography id="modal-modal-title" variant="h6" component="h2" className="mb20">
                Edit Your Profile
              </Typography>
              <TextField
                fullWidth
                label="Username"
                name="username"
                className="mb20 mt20"
                value={user.username}
                onChange={handleInput}
              />
              <TextField
                fullWidth
                label="Mobile"
                name="mobile"
                className="mb20 mt20"
                disabled
                value={user.mobile}
                onChange={handleInput}
              />
              <TextField
                fullWidth
                label="Email"
                name="email"
                className="mb20 mt20"
                value={user.email}
                onChange={handleInput}
              />
              <Button
                variant="outlined"
                className="mb20 mt20"
                fullWidth
                onClick={EditUserData}
              >
                Save Changes
              </Button>
            </Box>
          </Modal>

          {/* Modal for Editing User Password */}
          <Modal
            open={openPass}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="edit-modal">
              <IconButton
                onClick={handleClosePass}
                style={{ position: 'absolute', top: '10px', right: '10px' }}
              >
                <CloseIcon />
              </IconButton>
              <Typography id="modal-modal-title" variant="h6" component="h2" className="mb20">
                Change Your Password
              </Typography>

              <TextField
                fullWidth
                label="Current Password"
                name="currentPassword"
                type="password"
                className="mb20 mt20"
                value={passwordData.currentPassword}
                onChange={handleInputChange}
              />
              <TextField
                fullWidth
                label="New Password"
                name="newPassword"
                type="password"
                className="mb20 mt20"
                value={passwordData.newPassword}
                onChange={handleInputChange}
              />
              <TextField
                fullWidth
                label="Confirm New Password"
                name="confirmNewPassword"
                type="password"
                className="mb20 mt20"
                value={passwordData.confirmNewPassword}
                onChange={handleInputChange}
              />
              <Button
                variant="outlined"
                className="mb20 mt20"
                fullWidth
                onClick={handleChangePassword}
              >
                Change Password
              </Button>
            </Box>
          </Modal>

        </Container>
      </Layout>
    </Fragment>
  );
};

export default Account;
